export class Prop {
    constructor(rootSymbol, next) {
        this.rootSymbol = rootSymbol;
        this.next = next;
        if (next === undefined) {
            this.next = null;
        }
    }
    apply(env) {
        // This feels wrong, revisit
        if (this.next == null) {
            return env[this.rootSymbol];
        }
        else if (this.next instanceof Prop) {
            return this.next.apply(env[this.rootSymbol] || {});
        }
        else {
            return env[this.rootSymbol][this.next] || null;
        }
    }
}
export class Const {
    constructor(value) {
        this.value = value;
    }
    apply(_env) {
        return this.value;
    }
}
export class UnaryOperator {
    constructor(param) {
        this.param = param;
    }
}
export class BinaryOperator {
    constructor(left, right) {
        this.left = left;
        this.right = right;
    }
}
export class SetWiseOperator extends BinaryOperator {
    apply(env) {
        return this.rawOperator(this.left.apply(env), this.right.apply(env));
    }
}
export class ComparatorOperator extends BinaryOperator {
    apply(env) {
        return this.rawOperator(this.left.apply(env), this.right.apply(env));
    }
}
